import Vue from 'vue';
import App from './App.vue';
import Accordion from '@/components/standard/Accordion.vue';
import Card from '@/components/Card.vue';
import DrugFactIndex from '@/components/drug_facts/DrugFactIndex.vue';
import DrugOverlay from '@/components/drug_facts/DrugOverlay.vue';
import DrugSearch from '@/components/drug_facts/DrugSearch.vue';
import Navbar from '@/components/nav/Navbar.vue';
import NavbarMenuItem from '@/components/nav/NavbarMenuItem.vue';
import NavbarSubmenuItem from '@/components/nav/NavbarSubmenuItem.vue';
import ResourceIndex from '@/components/resources/ResourceIndex.vue';
import ServiceIndex from '@/components/services/ServiceIndex.vue';
import ShopProduct from '@/components/standard/ShopProduct.vue';
import Sidenav from '@/components/nav/Sidenav.vue';
import SidenavBlock from '@/components/nav/SidenavBlock.vue';
import SubscribeForm from '@/components/subscribe/SubscribeForm.vue';
import InsightIndex from '@/components/insights/InsightIndex.vue';
import Search from '@/components/search/Search.vue';
import store from './store';

Vue.config.productionTip = false;

new Vue({ // eslint-disable-line no-new
  el: '#app',
  store,
  components: {
    App,
    Accordion,
    Card,
    DrugFactIndex,
    DrugSearch,
    DrugOverlay,
    InsightIndex,
    Navbar,
    NavbarMenuItem,
    NavbarSubmenuItem,
    ResourceIndex,
    ServiceIndex,
    ShopProduct,
    Sidenav,
    SidenavBlock,
    SubscribeForm,
    Search,
  },
});

// Back to top

const setupBackToTop = () => {
  const backToTop = document.getElementsByClassName('js-back')[0];
  if (!backToTop) return;

  backToTop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });
};

// Modules

const setupPrintButton = () => {
  const button = document.getElementsByClassName('js-print')[0];
  if (!button) return;

  const header = document.getElementsByClassName('header')[0];

  button.addEventListener('click', (e) => {
    e.preventDefault();

    header.style.position = 'absolute';
    window.print();
    header.style.position = 'fixed';
  });
};

// Insights

const setupInsightTiles = () => {
  const items = document.getElementsByClassName('js-insight_tile');
  if (!items.length) return;

  // In VuejS, .is-loading class should be removed after the tile loads into view
  [].forEach.call(items, (item, index) => {
    if (item.classList.contains('is-loading')) {
      setTimeout(() => item.classList.remove('is-loading'), 180 * index);
    }
  });
};

// Home

const offsetY = (e) => {
  let element = e;
  let top = 0;

  do {
    top += element.offsetTop || 0;
    element = element.offsetParent;
  } while (element);

  return top;
};

const setupHomeUnderlay = () => {
  const sections = document.getElementsByClassName('js-home_sections')[0];
  const underlay = document.getElementsByClassName('js-home_underlay')[0];
  if (!sections || !underlay) return;

  // Max opacity value
  const maxOpacity = 0.85;
  // Y position to start opacity change from 0
  const opacityStart = offsetY(underlay) - (underlay.offsetHeight * 0.2);
  // Y position to finish opacity change at max opacity value
  const opacityFinish = offsetY(underlay) + (underlay.offsetHeight * 0.2);
  // Canvas size of opacity change
  const canvas = opacityFinish - opacityStart;
  // Buffer for fast scroll to make sure opacity is able to reach closer to <= 0
  const buffer = -0.1;

  let scrolled = (window.scrollY - opacityStart) / canvas;
  let opacity = (scrolled <= maxOpacity) ? scrolled.toFixed(2) : maxOpacity;
  if (scrolled >= buffer) underlay.style.opacity = opacity;

  window.addEventListener('scroll', () => {
    scrolled = (window.scrollY - opacityStart) / canvas;
    if (scrolled >= buffer) {
      opacity = (scrolled <= maxOpacity) ? scrolled.toFixed(2) : maxOpacity;
      underlay.style.opacity = opacity;
    }
  });
};

/**
 * Fallback manual requestAnimFrame function
 */
const manualAnimationFrame = (callback) => {
  window.setTimeout(callback, 1000 / 60);
};

/**
 * Shim requestAnimFrame
 */
window.requestAnimFrame = () => window.requestAnimationFrame
|| window.webkitRequestAnimationFrame
|| window.mozRequestAnimationFrame
|| manualAnimationFrame;

/**
 * Custom eased scroll to function because
 * Safari & IE doesn't support window.scrollTo options
 */
export default function scroll(y, duration) {
  const initialY = document.documentElement.scrollTop || document.body.scrollTop;
  const baseY = (initialY + y) * 0.5;
  const difference = initialY - baseY;
  const startTime = performance.now();

  function step() {
    let normalizedTime = (performance.now() - startTime) / duration;
    if (normalizedTime > 1) normalizedTime = 1;

    window.scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI));
    if (normalizedTime < 1) window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);
}

const setupHomeHeroScroll = () => {
  const sections = document.getElementsByClassName('js-home_sections')[0];
  const button = document.getElementsByClassName('js-hero_scroll')[0];
  if (!sections || !button) return;

  let y = offsetY(sections);

  window.addEventListener('resize', () => {
    y = offsetY(sections);
  });

  button.addEventListener('click', (e) => {
    e.preventDefault();
    scroll(y, 600);
    button.blur();
  });
};

const setupHomeDrugsSlide = () => {
  let index = 0;
  const items = document.getElementsByClassName('js-home_drug');
  if (!items.length) return;

  items[index].classList.add('is-active');
  if (items.length < 2) return;

  setInterval(() => {
    const next = (index + 1) % items.length;
    items[index].classList.remove('is-active');
    setTimeout(() => items[next].classList.add('is-active'), 100);
    index = next;
  }, 5000);
};

const init = () => {
  // Back to Top
  setupBackToTop();

  // Modules
  setupPrintButton();

  // Insights
  setupInsightTiles();

  // Home
  setupHomeUnderlay();
  setupHomeHeroScroll();
  setupHomeDrugsSlide();
};

window.addEventListener('load', init);
